import { getSessionTracker } from 'util/session-tracker';

export const defaultErrorHandler =
  (errorBoundaryName: string) => (err: Error) => {
    getSessionTracker().captureException(err, {
      extra: {
        errorBoundaryName,
      },
    });
  };
